// extracted by mini-css-extract-plugin
export default {"title":"styles_title__ZP9oY","box":"styles_box__D5w+r","box_toggle":"styles_box_toggle__SYNgA","percent":"styles_percent__3Di07","is_open":"styles_is_open__4Bjqc"};